const PUBLISH_PROCESS_1 = '/icons/publish-process/offerProcess1.jpg';
const PUBLISH_PROCESS_2 = '/icons/publish-process/offerProcess2.jpg';
const PUBLISH_PROCESS_3 = '/icons/publish-process/offerProcess3.jpg';
export { PUBLISH_PROCESS_1, PUBLISH_PROCESS_2, PUBLISH_PROCESS_3 };
